<template>
	<DefaultLayout>
		<slot v-if="!mustBeSelected || selected"></slot>
	</DefaultLayout>
</template>

<script>
	import { Component, Vue, Prop } from 'vue-property-decorator';
	import { Getter, Action, Mutation } from 'vuex-class';
	import DefaultLayout from '../Default/index.vue';

    @Component({
        components: {
            DefaultLayout
        },
    })
    export default class AuthLayout extends Vue {
        @Getter('api/homey/selectedId') selectedId;
        @Getter('api/homey/selected') selected;
        @Getter('api/authenticated') authenticated;
        @Prop({ type: Boolean, default: true}) mustBeSelected;
        @Prop(String) redirectTo;

        created() {
            if (!this.authenticated) {
                this.$router.push({name: 'login', params: {redirectTo: this.redirectTo}});
            } else if (!this.selectedId && this.mustBeSelected) {
                this.$router.push({name: 'homeys', params: {redirectTo: this.redirectTo}});
            }
        }
    }
</script>